import React from 'react';
import GridLayout from 'src/components/GridLayout';
import WidgetRenderer from './Renderers/WidgetRenderer';

const PerspectiveRenderer = ({
  perspective,
  engagementId,
  workflowId,
  openModal,
  widgetProps
}: any) => (
  <GridLayout
    isDraggable={false}
    isResizable={false}
    autoSize
    verticalCompact={false}
    isDisplay
    measureBeforeMount
    useCSSTransforms={false}
    widgets={perspective.widgets}
    renderWidget={(_widget: any) => (
      <div key={_widget.id}>
        <WidgetRenderer
          widget={_widget}
          perspectiveType={perspective.perspectiveType}
          openModal={openModal}
          workflowId={workflowId}
          engagementId={engagementId}
          {...widgetProps}
        />
      </div>
    )}
  />
);

export default PerspectiveRenderer;
